export default __webpack_public_path__ + "static/media/backgroundSponsoredQuestion.819bf347.jpg";